export class AuthReauthenticationRequiredMessage {
}